export const productsModels = {
  transform: (data) => {
    return data.map((category) => ({
      ...category,
      products: category.products.map((product) => ({
        ...product,
        variants: product.variants.map((variant) => ({
          ...variant,
        })),
      })),
    }));
  },
};
